import { render, staticRenderFns } from "./LabelConfig.vue?vue&type=template&id=72e3e181&scoped=true&"
import script from "./LabelConfig.vue?vue&type=script&lang=js&"
export * from "./LabelConfig.vue?vue&type=script&lang=js&"
import style0 from "./LabelConfig.vue?vue&type=style&index=0&id=72e3e181&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e3e181",
  null
  
)

export default component.exports